/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Components.LocationPicker {
    "use strict";

    export class MeevoLocationPicker implements angular.IDirective {
        restrict = "A";
        scope = {
          onSwitchLocation: '&meevoLocationPicker',
          enableUserFilter: '=',
          excludeCurrentLocation: '=',
          hideHomeLocation: '=?',
          isDisabled: '&',
          isChangeLocation: '=?',
          excludeCallCenter: '='
        }

        link = (scope: any, ele: JQuery, attrs: angular.IAttributes) => {
            var modalService = this.modalService;

            // No onSwitchLocation function was provided... set it to null
            // so that default behavior will be executed.
            if (attrs["meevoLocationPicker"] == "") {
                scope.onSwitchLocation = null;
            }

          if (attrs["enableUserFilter"] === "") {
            scope.enableUserFilter = true;
          } else {
            scope.enableUserFilter = scope.$eval(attrs["enableUserFilter"]);
          }

          scope.excludeCallCenter = attrs["excludeCallCenter"] === "" ? false : scope.$eval(attrs["excludeCallCenter"]);

          function openModal() {
                // Do validation before open modal
                if (scope.isDisabled()) {
                    return false;
              }


                let options: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: "app/components/locationPicker/locationPicker.html",
                    controller: "meevo.components.locationPicker.LocationPickerController",
                    controllerAs: "locationPicker",
                    bindToController: true,
                    preserveScope: true,
                    scope: scope
                }

                modalService.showCustom(options).then((result) => {

                });
            }
            
            ele.bind("click", openModal);
        }

        constructor(private $window: angular.IWindowService,
                    private modalService: Meevo.Components.Modal.IModalService,
                    private appSettings: Meevo.Components.Common.IAppSettings,
                    private identityService: Meevo.Components.Common.IIdentityService,
                    private dataService: Meevo.Components.BaseClasses.IDataService)
        {
            
        }

        static factory(): angular.IDirectiveFactory {
            let directive = ( $window: angular.IWindowService,
                modalService: Meevo.Components.Modal.IModalService,
                 appSettings: Meevo.Components.Common.IAppSettings,
                 identityService: Meevo.Components.Common.IIdentityService,
                 dataService: Meevo.Components.BaseClasses.IDataService) => {
                return new MeevoLocationPicker($window, modalService, appSettings, identityService, dataService);
            };

            directive.$inject = ["$window",
                "meevo.components.modal.ModalService",
                "meevo.AppSettings",
                "meevo.components.common.IdentityService",
                "meevo.components.common.DataService"];

            return directive;
        }
    }

    angular.module("meevo.components.locationPicker")
        .directive("meevoLocationPicker", MeevoLocationPicker.factory());
}
 